<template>
  <v-dialog :value="showAccessDialog" persistent max-width="600">
    <v-form class="w-100" ref="requestAccessFormRef">
      <v-card class="flex-col-start-start gap-2 pa-6">
        <div class="text-body-2">{{ $t("noAccessMessage") }}</div>
        <div class="flex-row-start-center gap-2 mb-4">
          <div class="text-body-2">{{ $t("noAccessNavigate") }}</div>
          <v-btn
            v-for="(route, page) in otherRoutes"
            :key="page"
            @click="handleNavigate(route)"
            color="mainBlue"
            class="mainBlue--text"
            height="20px"
            text
          >
            {{ $t(page) }}
          </v-btn>
        </div>
        <v-card
          v-for="item in Object.keys(values)"
          :key="item"
          outlined
          min-height="65px"
          class="w-100 px-4 py-2 direction-ltr flex-row-start-center gap-3"
        >
          <div class="prediction-result-title">{{ $t(item) }}</div>
          <v-text-field
            class="prediction-result"
            background-color="background"
            :rules="[rules.required]"
            type="number"
            dense
            flat
            solo
            :suffix="`(${units[item]})`"
            v-model="values[item]"
            full-width
          />
        </v-card>
        <div class="flex-row-center-center w-100">
          <v-btn
            color="mainBlue"
            class="white--text mt-3"
            min-width="200px"
            :loading="loading"
            @click="handleSubmit"
          >
            {{ $t("save") }}
          </v-btn>
        </div>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { RECOMMENDATION_UNIT, VALIDATION_RULES } from "@/core/constants";
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";
import {
  REQUEST_ACCESS,
  SET_ACCESS,
} from "@/core/services/store/modules/user/user.module";
import { ROUTES } from "@/routes/pwa";
import { mapGetters } from "vuex";

export default {
  name: "AccessDialog",

  data() {
    return {
      loading: false,
      rules: VALIDATION_RULES,
      units: RECOMMENDATION_UNIT,
      values: {
        carbon: null,
        metallization: null,
        productionRate: null,
      },
      otherRoutes: {
        balance: ROUTES.balance,
        balanceHistory: ROUTES.balanceHistory,
        help: ROUTES.help,
      },
    };
  },

  computed: {
    ...mapGetters(["hasPanelAccess", "isAuthenticated"]),
    showAccessDialog() {
      return !this.hasPanelAccess && this.isAuthenticated;
    },
  },

  methods: {
    handleNavigate(route) {
      this.$store.commit(SET_ACCESS, true);
      this.$router.push(route);
    },
    async handleSubmit() {
      const isValid = this.$refs.requestAccessFormRef.validate();
      if (isValid) {
        this.loading = true;
        await this.$store
          .dispatch(REQUEST_ACCESS, this.values)
          .then(() => {
            this.$router.go(0);
          })
          .catch((error) => {
            this.$store.commit(SET_ALERT, {
              text: error.message || this.$t("accessRequestError"),
              isError: true,
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
